import getJSONFromFile from '@/util/fileUtility'

const swiftSettings = getJSONFromFile('swift.json')

export default swiftSettings
